import Vue from 'vue'
import VueRouter from 'vue-router'
import mainlayout from '../layout/mainlayout'
import authlayout from '../layout/authlayout'
import Home from '../views/Home'
import Login from '../views/Login'
import SignUp from '../views/SignUp'
import ForgotPassword from '../views/ForgotPassword'
import VerificationPage from '../views/VerificationPage'
import ImportWishList from '../views/ImportWishList'
import SetNewPassword from '../views/SetNewPassword'
import SetDiscountRate from '../views/SetDiscountRate'
import EarnCrypto from '../views/EarnCrypto'
import Orders from '../views/Orders'
import ViewOrder from '../views/ViewOrder'
import Profile from '../views/Profile'
import TransactionHistory from '../views/TransactionHistory'
import Wallet from '../views/Wallet'
import WalletWithdraw from '../views/WalletWithdraw'
import ModifyOffer from '../views/ModifyOffer'
import TwoFaAuth from '../views/TwoFaAuth'

Vue.use(VueRouter)
  const routes = [
    {
      path: '/',
      redirect: 'home',
      component: mainlayout,
      children: [
        {
          path: '/home',
          name: 'Home',
          component: Home
            
        },
        {
          path: '/login',
          name: 'Login',
          component: Login
            
        },
        {
          path: '/signup',
          name: 'SignUp',
          component: SignUp
        },
        {
          path: '/forgotpassword',
          name: 'ForgotPassword',
          component: ForgotPassword
        },
        {
          path: '/importwishlist',
          name: 'ImportWishlist',
          component: ImportWishList
        },
        {
          path: '/setdiscount',
          name: 'SetDiscountRate',
          component: SetDiscountRate
        },
        {
          path: '/earncrypto',
          name: 'EarnCrpto',
          component: EarnCrypto
        },
        {
          path: '/orders',
          name: 'Orders',
          component: Orders
        },
        {
          path: '/orders/:id',
          name: 'ViewOrder',
          component: ViewOrder
        },
        {
          path: '/profile',
          name: 'Profile',
          component: Profile
        },
        {
          path: '/transactionhistory',
          name: 'TransactionHistory',
          component: TransactionHistory
        },
        {
          path: '/wallet',
          name: 'Wallet',
          component: Wallet
        },
        {
          path: '/wallet/withdraw',
          name: 'WalletWithdraw',
          component: WalletWithdraw
        },
        {
          path: '/modifyorder',
          name: 'ModifyOffer',
          component: ModifyOffer   
        },
       
         
      ]
    },
    {
      path: '/verifyuser',
      // redirect: 'home',
      component: authlayout,
      children: [
        {
          path: '/verifyuser',
          name: 'VerificationPage',
          component: VerificationPage
        },
        {
          path: '/setnewpassword',
          name: 'SetNewPassword',
          component: SetNewPassword
        },
        {
          path: '/twofactorauth',
          name: 'TwoFaAuth',
          component: TwoFaAuth
        },
      ]
    }
  
]

const router = new VueRouter({
  routes,
  base: process.env.BASE_URL,
})

export default router
